// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2AK3Z","requiredAsterisk":"Info_requiredAsterisk__1PSG3"};